export default __webpack_public_path__ + "static/media/archi-pc.b01232d7.gif";